import { ThemeIcon } from '../../../DataDisplay/ThemeIcon';

interface ColoredMapMarkerProps {
  color?: 'mint' | 'cobalt';
}

const MapPinMarker = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M11.7573 12.1967C13.099 12.1967 14.1967 11.099 14.1967 9.75734C14.1967 8.4157 13.099 7.318 11.7573 7.318C10.4157 7.318 9.318 8.4157 9.318 9.75734C9.318 11.099 10.4157 12.1967 11.7573 12.1967ZM11.7573 0C16.8799 0 21.5147 3.92733 21.5147 10.0013C21.5147 13.8798 18.5265 18.4414 12.5623 23.6981C12.0988 24.1006 11.4036 24.1006 10.9402 23.6981C4.98818 18.4414 2 13.8798 2 10.0013C2 3.92733 6.63474 0 11.7573 0Z"
        fill="currentColor"
      />
    </svg>
  );
};

const MapMarker = ({ color = 'cobalt' }: ColoredMapMarkerProps) => {
  return (
    <ThemeIcon
      variant="transparent"
      c={color}
      size="lg"
      style={{ boxShadow: 'var(--mantine-shadow-sm' }}
    >
      <MapPinMarker />
    </ThemeIcon>
  );
};

export { MapMarker };
